<template>
    <div
        data-prices-slider
        v-if="prices.length"
    >
        <p class="text-xs sm:text-sm font-semibold text-brand-2-950 mb-3">
            Weekend Pricing
        </p>

        <div :class="{ 'opacity-60 pointer-events-none': loading }">
            <Slider
                v-model="prices"
                :min="priceMin"
                :max="priceMax"
                :step="100"
                :tooltips="false"
                @update="$emit('pricesChanged', prices)"
            />

            <div class="mt-3 flex justify-between font-semibold text-brand-2-950 text-xsss sm:text-xs">
                <p>
                    <span v-text="GBP.format(prices[0])"></span>
                </p>
                <p>
                    <span v-text="GBP.format(prices[1])"></span>
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref } from 'vue';

    import Slider from '@vueform/slider';

    const GBP = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 0,
    });

    const props = defineProps([
        'loading',
    ]);

    const emit = defineEmits(['selected', 'pricesChanged']);

    const priceMin = ref(Filters.priceMin);
    const priceMax = ref(Filters.priceMax);

    const prices = ref([Filters.priceMinCurrent ?? priceMin.value, Filters.priceMaxCurrent ?? priceMax.value]);
</script>
